import { Card, Grid } from '@mui/material'
import stormError from 'assets/pictures/pictos/stormError.png'
import React from 'react'
import i18n from 'simple-react-i18n'

const AquaKwak = () => (
    <Card sx={{ margin: '1rem' }} data-cy='page-error'>
        <Grid container direction={'column'} padding={2}>
            <img
                src={stormError}
                style={{
                    display: '>block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: '20%',
                }}
            />
            <h1 style={{ textAlign: 'center' }}>
                {i18n.somethingWentWrong}
            </h1>
            <label style={{ textAlign: 'center', fontSize: '2rem' }}>
                {i18n.sorryError}
            </label>
        </Grid>
    </Card>
)

export default AquaKwak